import React from 'react';

export default class LazyLoad extends React.Component {
    constructor(...args) {
        super(...args);
        this.activated = false;
    }

    render() {
        if((!this.activated && this.props.show) || this.activated) {
            this.activated = true;
            return this.props.children;
        }

        return <div></div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/LazyLoad/LazyLoad.js